import React from "react";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";

function CommonRadioButton({handleChangeValue,selectRadioBtn}) {

  return (
      <RadioGroup
        row
        aria-labelledby="demo-row-radio-buttons-group-label"
        name="row-radio-buttons-group"
        value={selectRadioBtn}
        onChange={handleChangeValue}
      >
        <FormControlLabel
          value="MOBILE"
          control={
            <Radio
              sx={{
                "& .MuiSvgIcon-root:not(.MuiSvgIcon-root ~ .MuiSvgIcon-root)": {
                  color: "#E42125",
                },
                "& .MuiSvgIcon-root + .MuiSvgIcon-root": {
                  color: "#E42125",
                },
              }}
            />
          }
          label="Mobile No."
        />
        <FormControlLabel
          value="DOB"
          control={
            <Radio
              sx={{
                "& .MuiSvgIcon-root:not(.MuiSvgIcon-root ~ .MuiSvgIcon-root)": {
                  color: "#E42125",
                },
                "& .MuiSvgIcon-root + .MuiSvgIcon-root": {
                  color: "#E42125",
                },
              }}
            />
          }
          label="Date of Birth"
        />
      </RadioGroup>
  );
}

export default CommonRadioButton;
